<template>
  <div>
    <div class="md-modal modal-msg md-modal-transition" v-bind:class="{'md-show':c_mdshow}">
      <div class="md-modal-inner">
        <div class="md-top">
          <button class="md-close" @click = 'closeModal'>Close</button>
        </div>
        <div class="md-content">
          <div class="confirm-tips">
            <slot name="msg"></slot>
          </div>
          <div class="btn-wrap">
            <slot name = "btnGroup"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class = 'md-overlay' v-if="c_mdshow" @click = 'closeModal'></div>
  </div>

</template>

<script>
    export default {
      props:['c_mdshow'],

      methods:{
        closeModal(){
          this.$emit('c_close')

        }
      }
    }
</script>





// WEBPACK FOOTER //
// src/components/Modal.vue